<template>
  <section class="error-scan-container">
    <div>
      <Icon type="md-alert" class="icon-error"/>
      <p>{{ desc }}</p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'error_scanerror',
  data () {
    return {
      desc: ''
    }
  },
  mounted () {
    this.desc = this.$route.query.message
  }
}
</script>

<style lang="less" scoped>
.error-scan-container {
  display: flex;
  height: 80vh;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  color: #000;
  div {
    text-align: center;
  }
  .icon-error {
    color: sandybrown;
    font-size: 120px;
    margin-bottom: 80px;
  }
}
</style>
